/**
 * File utility functions
 * Fixes Bug #12: Avoid code duplication
 */

export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return bytes + ' B';
  if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
  if (bytes < 1024 * 1024 * 1024) return (bytes / 1024 / 1024).toFixed(1) + ' MB';
  return (bytes / 1024 / 1024 / 1024).toFixed(1) + ' GB';
}

export function validateFilePath(path: string): string | null {
  /**
   * Validate Dropbox file path
   * Fixes Bug #11: Comprehensive path validation
   */
  if (!path) {
    return 'File path is required';
  }
  
  if (!path.startsWith('/')) {
    return 'File path must start with "/" (e.g., "/Documents/file.txt")';
  }
  
  if (path.length > 1000) {
    return 'File path too long (max 1000 characters)';
  }
  
  // Check for invalid characters (Windows-style)
  const invalidChars = /[<>"|?*\x00-\x1F]/;
  if (invalidChars.test(path)) {
    return 'File path contains invalid characters';
  }
  
  return null;
}

export function getFileExtension(filename: string): string {
  const parts = filename.split('.');
  return parts.length > 1 ? '.' + parts[parts.length - 1].toLowerCase() : '';
}

export function isTextFile(filename: string): boolean {
  const textExtensions = new Set([
    '.txt', '.md', '.json', '.xml', '.csv', '.log',
    '.py', '.js', '.ts', '.tsx', '.jsx', '.html', '.css', '.scss',
    '.java', '.c', '.cpp', '.h', '.go', '.rs', '.rb', '.php',
    '.sh', '.bash', '.yaml', '.yml', '.toml', '.ini', '.env'
  ]);
  
  const ext = getFileExtension(filename);
  return textExtensions.has(ext);
}
